import React, { useState } from "react";
import "./EnglishExamGuide.css";

import greimg from "../../Assets/TEST-PRE/GRE-Exam.jpg";
import gmatimg from "../../Assets/TEST-PRE/GMAT.jpg";
import ieltsImg from "../../Assets/TEST-PRE/IELTS-Exam.jpg";
import toeflImg from "../../Assets/TEST-PRE/TOEFL-Exam.jpg";
import pteImg from "../../Assets/TEST-PRE/PTE-Exam.jpg";

const EnglishExamGuide = () => {
  const [activeExam, setActiveExam] = useState("GRE");
  const [activeSection, setActiveSection] = useState("Exam Formats");

  const examData = {

     GRE: {
      img: greimg,
      title: "GRE Exam Overview",
      subtitle: "What Is the GRE Exam?",
      desc: "The GRE exam, administered by ETS, is a standardized test widely used for admissions into graduate and doctoral programs globally. The test evaluates your analytical writing, verbal reasoning, and quantitative reasoning skills.",
      sections: {
        "Test Format": <>
        <ul>
          <li><b>Analytical Writing: </b>1 issue and 1 argument task</li>
          <li><b>Verbal Reasoning: </b>Two sections</li>
          <li><b>Quantitative Reasoning: </b>Two sections</li>
          <li>Plus one experimental or unscored section
 Duration: About 3 hours 45 minutes
</li>
        </ul>

        <b>Test Duration:</b> <br/><br/>
        <p>Approximately 2 hours 45 minutes; Listening, Reading, Writing are taken in one day, with Speaking either same day or within a week.</p></>,
         "Scoring & Results": <>
        <ul>
          <li><b>Analytical Writing:</b> 0.0–6.0 (0.5 increments)</li>
           <li><b>Verbal & Quantitative: </b>130–170 (1-point increments)
 – Scores valid for 5 years; cost typically USD 205</li>
        </ul>
        </>,
         "GRE Practice Test Tips": <>
        <ul>
          <li>Use official PowerPrep materials from ETS for realistic practice.</li>
          <li>Amplify your preparation with topic-wise practice: text completion, sentence equivalence, reading comprehension, quant challenges.</li>
          <li>Practice under timed conditions and review weak areas.</li>
        </ul>
        </>,
          "How to Prepare Best": <>
        <ul>
          <li>Start with official ETS guides and PowerPrep software.</li>
           <li>Use topic-wise drills: analytical writing, quant problems, vocab (text completions, sentence equivalence).</li>
            <li>Take full-length GRE practice tests, review performance, and focus on weak sections</li>
        </ul>
        </>,
         "Registration & Test Day": <>
        <ul>
          <li><b>Registration:</b> Available online via ETS.</li>
           <li><b>Select:</b> Your test center, date, and preferred format (computer-based or paper-based).</li>
            <li><b>Registration:</b> Up to 5 times a year with 21 days between attempts.</li>
        </ul>
        </>,
      }
    },

    GMAT: {
  img: gmatimg,
  title: "GMAT Exam Overview",
  subtitle: "What Is the GMAT Exam?",
  desc: "The GMAT (Graduate Management Admission Test), administered by GMAC, is a standardized test required for admission to many MBA and business master’s programs worldwide. It evaluates analytical writing, quantitative, verbal, and integrated reasoning skills essential for business school success.",
  sections: {
    "Test Format": <>
      <ul>
        <li><b>Analytical Writing Assessment (AWA):</b> 1 essay task (30 minutes)</li>
        <li><b>Integrated Reasoning:</b> 12 questions (30 minutes)</li>
        <li><b>Quantitative Section:</b> 31 questions (62 minutes)</li>
        <li><b>Verbal Section:</b> 36 questions (65 minutes)</li>
      </ul>
      <b>Test Duration:</b> <br/><br/>
      <p>Approximately 3 hours 7 minutes (excluding breaks).</p>
    </>,
    
    "Scoring & Results": <>
      <ul>
        <li><b>Total Score:</b> 200–800 (in 10-point increments)</li>
        <li><b>AWA:</b> 0–6 (0.5 increments)</li>
        <li><b>Integrated Reasoning:</b> 1–8 (1-point increments)</li>
        <li><b>Quantitative & Verbal:</b> 6–51 each (scaled scores)</li>
        <li>Scores valid for 5 years; cost typically USD 275</li>
      </ul>
    </>,
    
    "GMAT Practice Test Tips": <>
      <ul>
        <li>Use official GMAT prep resources from mba.com for realistic practice.</li>
        <li>Practice data sufficiency and critical reasoning regularly.</li>
        <li>Take timed mock tests to improve speed and accuracy.</li>
      </ul>
    </>,
    
    "How to Prepare Best": <>
      <ul>
        <li>Start with GMAT Official Guide and GMATPrep software.</li>
        <li>Focus on quantitative problem-solving, verbal reasoning, and integrated reasoning drills.</li>
        <li>Analyze mistakes from practice tests to strengthen weak areas.</li>
      </ul>
    </>,
    
    "Registration & Test Day": <>
      <ul>
        <li><b>Registration:</b> Available online at mba.com.</li>
        <li><b>Select:</b> Your test center or choose GMAT Online for remote testing.</li>
        <li><b>Attempts:</b> Up to 5 times in a rolling 12-month period, 8 times lifetime limit.</li>
      </ul>
    </>,
  }
},




    IELTS: {
      img: ieltsImg,
      title: "IELTS Exam Overview",
      subtitle: "What Is the IELTS Exam?",
      desc: "The IELTS exam—International English Language Testing System—is recognized by 10,000+ universities, employers, and immigration authorities worldwide—including UK, Australia, Canada, and more.",
      sections: {
        "Exam Formats": <><b>Two versions are available:</b> <br/><br/>
        <ul>
          <li>Academic (for University admission)</li>
          <li>General Training (for work, migration)</li>
          <li>Both versions test four key skills: Listening, Reading, Writing, and Speaking.</li>
        </ul>

        <b>Test Duration:</b> <br/><br/>
        <p>Approximately 2 hours 45 minutes; Listening, Reading, Writing are taken in one day, with Speaking either same day or within a week.</p></>,
        "Section Breakdown": <>
        <ul>
          <li><b>Listening: </b> 4 recordings, ~30 min plus transfer time.</li>
           <li><b>Reading: </b>  3 passages—Academic or General Training format; 60 minutes.</li>
            <li><b>Writing: </b> <br/> Task 1: Describe data (150 words, Academic) or write a letter (General, 150 words), <br/> Task 2: Essay (250 words)
 Total writing time: 60 min</li>
   <li><b>Speaking: </b>  A face-to-face interview with three parts (11–14 minutes).</li>
        </ul>
        </>,
         "Scoring & Results": <>
        <ul>
          <li>Each section scored 0–9 band.</li>
           <li>Overall band is average of four module scores.</li>
            <li>Scores valid for 2 years.</li>
        </ul>
        </>,
         "Writing Tips (Academic)": <>
        <ul>
          <li><b>Task 1:</b> Use structure—Introduction, Overview, Details; avoid raw data in overview</li>
          <li><b>Task 2:</b> Use clear thesis, support with examples, and proper formal tone</li>
        </ul>
        </>,
          "Preparation Strategies": <>
        <ul>
          <li>Practice Timed Essays and Descriptions</li>
           <li>Read model answers and sample questions</li>
            <li>Join speaking groups or record yourself to improve fluency</li>
            <li>Focus on coherence, grammar, vocabulary, and academic style.</li>
        </ul>
        </>,
      }
    },

     TOEFL: {
      img: toeflImg,
      title: "TOEFL Exam Overview",
      subtitle: "What Is the TOEFL Exam?",
      desc: "The TOEFL exam (Test of English as a Foreign Language) assesses your academic English ability in Reading, Listening, Speaking, and Writing. It’s commonly used by universities in the U.S., Canada, and other English-speaking countries.",
      sections: {
        "TOEFL Formats": <>
        <ul>
          <li>Most common version: TOEFL iBT (Internet-based Test)</li>
          <li>Skills tested: Reading, Listening, Speaking, Writing</li>
          <li>Fully computer-based format</li>
        </ul>
        <b>Why TOEFL?</b> <br/><br/>
        <p>Preferred in North American universities, TOEFL evaluates academic comprehension and expression. It provides a standardized benchmark for admissions decisions.</p></>,
        "Exam Structure": <>
        <ul>
          <li><b>Reading (35–56 minutes):</b> 3–4 passages from academic texts, 10 questions per passage, Tests comprehension, vocabulary, and ability to identify ideas and arguments.</li>
          <li><b>Listening (41–57 minutes):</b> Conversations and lectures in academic settings, Includes both factual and inference-based questions.</li>
          <li><b>Speaking (17 minutes):</b> 4 tasks: some based on personal opinion, others combining listening and reading inputs, Responses recorded and scored by certified examiners.</li>
           <li><b>Writing (50 minutes):</b> <br/>Integrated Task: Read a passage, listen to audio, and then write a summary,<br/> Independent Task: Write an essay based on your opinion or argument.</li>
        </ul>
        <b>Why TOEFL?</b> <br/><br/>
        <p>Preferred in North American universities, TOEFL evaluates academic comprehension and expression. It provides a standardized benchmark for admissions decisions.</p></>,
        "Scroring": <>
        <ul>
          <li><b>Total Score Range:</b> 0–120</li>
          <li><b>Each section:</b>  0–30 points</li>
          <li>Many top universities require 90+ overall, but competitive programs often look for 100+.</li>
        </ul>
       </>,
          "Preparation Tips": <>
        <ul>
          <li>Practice academic passages and lectures.</li>
           <li>Develop note-taking skills, especially for Listening and Speaking.</li>
            <li>Simulate test conditions with timed practice tests.</li>
            <li>Improve typing speed—Writing is typed on a computer.</li>
        </ul>
        </>,
      }
    },
  
     PTE: {
      img: pteImg,
      title: "PTE Exam Overview",
      subtitle: "What Is the PTE Exam?",
      desc: "The PTE Academic is a fully computer-based English proficiency test accepted by universities and governments worldwide, including Australia, New Zealand, UK, and Canada",
      sections: {
        "Exam Structure": <>PTE tests Speaking & Writing, Reading, and Listening in a single three-hour session. AI technology scores responses quickly—results are usually available within 48 hours.<br/><br/>
        <b>Advantages of PTE:</b>
        <ul>
          <li>Fast scoring through AI</li>
          <li>Flexible and frequent test dates</li>
          <li>High acceptability among institutions</li>
        </ul>
        </>,
          "How to Prepare": <>
        <ul>
          <li>Practice with full digital mock tests</li>
           <li>Focus on fluency and typing accuracy for tasks like “describe image” or essays</li>
            <li>Use PTE-style questions to build familiarity</li>
        </ul>
        </>,
      }
    },
    
  };

  const data = examData[activeExam];

  return (
    <section className="exam-guide-section">
      {/* Top Heading */}
      <div>
        <h2 className="text-center heading mb-5 mt-5">Your Guide to English Exam <br />for Studying Abroad</h2>
      </div>

      {/* Top Filter */}
      <div className="exam-guide-filter-buttons">
        {Object.keys(examData).map((exam) => (
          <button
            key={exam}
            className={`exam-guide-filter-btn ${
              activeExam === exam ? "exam-guide-active" : ""
            }`}
           onClick={() => {
  setActiveExam(exam);
  setActiveSection(Object.keys(examData[exam].sections)[0]); // pick first section
}}
          > <h3>{exam} Exam</h3>
            
          </button>
        ))}
      </div>

      {/* Overview */}
      <div className="exam-guide-overview">
        <img src={data.img} alt={data.title} className="exam-guide-img" />
        <div className="exam-guide-overview-text">
          <h4 className="exam-guide-title">{data.title}</h4>
          <h4 className="exam-guide-title">{data.subtitle}</h4>
          <p className="exam-guide-desc">{data.desc}</p>
        </div>
      </div>

      <hr className="exam-guide-divider" />

      {/* Bottom Filter */}
      <div className="exam-guide-bottom">
        {/* Left Menu */}
        <div className="exam-guide-left-menu">
          <h3 className="exam-guide-left-title">
            A Complete Guide to the {activeExam} Exam
          </h3>
          {Object.keys(data.sections).map((section) => (
            <p
              key={section}
              className={`exam-guide-link ${
                activeSection === section ? "exam-guide-link-active" : ""
              }`}
              onClick={() => setActiveSection(section)}
            >
              {section}
            </p>
          ))}
        </div>

        {/* Right Content */}
        <div className="exam-guide-right-content">
          <h3 className="exam-guide-right-title">{activeSection}</h3>
          <p className="exam-guide-right-text">
            {data.sections[activeSection]}
          </p>
        </div>
      </div>
    </section>
  );
};

export default EnglishExamGuide;
